"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = exports.dateParse = void 0;
const tslib_1 = require("tslib");
const dayjs_1 = tslib_1.__importDefault(require("dayjs"));
const localizedFormat_1 = tslib_1.__importDefault(require("dayjs/plugin/localizedFormat"));
dayjs_1.default.extend(localizedFormat_1.default);
function dateParse(date) {
    if (!date) {
        return undefined;
    }
    return (0, dayjs_1.default)(date).toDate();
}
exports.dateParse = dateParse;
function formatDate(value, format = 'lll', fallback = '') {
    if (!value) {
        return fallback;
    }
    return (0, dayjs_1.default)(value).format(format);
}
exports.formatDate = formatDate;
//# sourceMappingURL=date-parse.js.map